module.exports = __webpack_public_path__ + "img/confirm.87fc9e95.png";